import {
  fetchGetAssociatedPeople,
  GetFundingRequirementResponse,
  GetCompanySearchResponse,
  GetPostcodeLookupResponse,
  PostPaymentMethodRequestBody,
  PostPaymentMethodResponse,
} from '@iwoca/lapi-client/v1';

import { LapiError } from './LapiError';
import {
  lendingApiFetchJson,
  postLendingApiJson,
} from '../../Pages/lendingApiFetch';

export type CompanySearchCompany = GetCompanySearchResponse['data'][0];

export const fetchGetCompanySearch = async ({
  companyName,
}: {
  companyName: string;
}): Promise<GetCompanySearchResponse> => {
  const res = await lendingApiFetchJson(
    `/api/lending/v1/company_search/?company_name=${companyName}`,
  );

  if (!res.ok) {
    throw new LapiError(res.status, await res.text());
  }

  return res.json();
};

export type ResidentialAddress = GetPostcodeLookupResponse['data'][0];

export type AssociatedPerson = {
  correspondence_address?: {
    house_name?: string;
    street_line_1?: string;
    postcode?: string;
    town?: string;
  };
  house_name?: string;
  postcode?: string;
  street_line_1?: string;
  town?: string;
  first_name?: string;
  last_name?: string;
  month_of_birth?: number;
  roles?: string[];
  year_of_birth?: number;
};

export type GetAssociatedPeopleResponse = {
  data?: {
    people?: AssociatedPerson[];
  };
};

export function fetchAssociatedPeople(
  stateKey: string,
): Promise<GetAssociatedPeopleResponse> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return fetchGetAssociatedPeople({ stateKey: stateKey! }) as any;
}

export const fetchGetPostCodeLookup = async ({
  postCode,
}: {
  postCode: string;
}): Promise<GetPostcodeLookupResponse> => {
  const res = await lendingApiFetchJson(
    `/api/lending/v1/postcode_lookup/?postcode=${postCode}`,
  );

  if (!res.ok) {
    throw new LapiError(res.status, await res.text());
  }

  return res.json();
};

export const fetchPostPaymentMethod = async ({
  stateKey,
  body,
}: {
  stateKey: string;
  body: PostPaymentMethodRequestBody;
}): Promise<PostPaymentMethodResponse> => {
  const res = await postLendingApiJson({
    url: `/api/lending/v1/payment_method/${stateKey}/`,
    body,
  });

  if (!res.ok) {
    throw new LapiError(res.status, await res.text());
  }

  return res.json();
};

export const fetchGetFundingRequirement = async ({
  stateKey,
  query: { amount, payLinkId },
}: {
  stateKey: string;
  query: {
    amount: number;
    payLinkId?: string;
  };
}): Promise<GetFundingRequirementResponse> => {
  const searchParams = new URLSearchParams();
  if (amount) searchParams.append('requested_amount', String(amount));
  if (payLinkId) searchParams.append('pay_link_id', payLinkId);

  const res = await lendingApiFetchJson(
    `/api/lending/v1/funding_requirement/${stateKey}/${
      searchParams ? `?${searchParams}` : null
    }`,
  );

  if (!res.ok) {
    throw new LapiError(res.status, await res.text());
  }

  return res.json();
};
